module.exports = __WEBPACK_EXTERNAL_MODULE_33__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/drawer/dist/mdc.drawer","commonjs2":"@material/drawer/dist/mdc.drawer","commonjs":"@material/drawer/dist/mdc.drawer","amd":"@material/drawer/dist/mdc.drawer","umd":"@material/drawer/dist/mdc.drawer"}
// module id = 33
// module chunks = 0